import { render, staticRenderFns } from "./AddProductData.vue?vue&type=template&id=5ea9a172&scoped=true"
import script from "./AddProductData.vue?vue&type=script&lang=js"
export * from "./AddProductData.vue?vue&type=script&lang=js"
import style0 from "./AddProductData.vue?vue&type=style&index=0&id=5ea9a172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea9a172",
  null
  
)

export default component.exports